import { Fragment } from 'react';
import { formatMoney_2, NumberToNepaliNum } from '../../../../helpers/DateFormat';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { useLanguage } from '../../../../context/LanguageProvider';
import { NepNowDateFormat } from '../../../../constants/DateFormat';
import AppURL from '../../../../constants/AppURL';

const PrintAdvanedVoucher = ({ onAdvVoucherReport }: any) => {
  const { SOFTWARE_ORG, ACCOUNT_RPT_DATE } = useSelector((state: RootState) => state.software);
  const org_details = SOFTWARE_ORG?.org;
  const date_report = ACCOUNT_RPT_DATE.acc_rpt;
  const { language } = useLanguage();
  const DateNow = NepNowDateFormat();
  const totalPartiCredit: number = onAdvVoucherReport?.results?.filter((item: any) => item?.glid !== 8)?.reduce(
    (sum: number, item: any) => sum + (item.particularcreditamt ? item.particularcreditamt : 0),
    0
  );

  const totalPartiDredit: number = onAdvVoucherReport?.results?.filter((item: any) => item?.glid !== 8)?.reduce(
    (sum: number, item: any) => sum + (item.particulardebitamt ? item.particulardebitamt : 0),
    0
  );

  const anotherCreditAmt: number = onAdvVoucherReport?.results?.filter((item: any) => item?.glid !== 8)?.reduce(
    (sum: number, item: any) => sum + (item.creditamt ? item.creditamt : 0),
    0
  );

  const anotherDebitAmt: number = onAdvVoucherReport?.results?.filter((item: any) => item?.glid !== 8)?.reduce(
    (sum: number, item: any) => sum + (item.debitamt ? item.debitamt : 0),
    0
  );
  return (
    <Fragment>
      <style>
        {`@media print {
            @page {
            size: A4 potrait;
            page-break-before: always;
            margin: 0.2in; 
            border: 1px solid black;
         }
        }`}
      </style>
      <div className='bg-white h-screen'>
        <div className="relative border border-gray-300 p-0.5">
          <table className="w-full text-sm text-left rtl:text-right text-black">
            <tbody>
              <tr>
                <td className={`w-[25%] text-[12px] text-black whitespace-nowrap ${language === "Eng" ? "font-public-sans" : "font-nepali"}`} >
                  {language === "Eng" ? "S. Code: " : "एस. कोड:"}:  {language === "Eng" ? org_details?.org_reg : NumberToNepaliNum(org_details?.org_reg || "")}
                </td>
                <td className="w-[25%]">
                </td>
                <td className="w-[25%]">
                </td>
                <td align='right' className={`w-[25%] text-[12px] text-black whitespace-nowrap ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Phone: " : "फोन नम्बर:"}  {language === "Eng" ? org_details?.org_phone : NumberToNepaliNum(org_details?.org_phone || 0)}
                </td>
              </tr>
              <tr >
                <td rowSpan={4} className="w-[25%] font-medium text-black whitespace-nowrap dark:text-white">
                  <img width={60} height={60} src={AppURL.BaseURL + org_details?.logo} alt="" />
                </td>
                <td align='center' colSpan={2} className={`w-[25%] text-black font-bold text-[18px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? org_details?.org_name : org_details?.org_name_nep}
                </td>
                <td className="w-[25%]">
                </td>
              </tr>
              <tr >
                <td align='center' colSpan={2} className={`w-[25%] text-black font-normal text-[12px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? org_details?.org_add : org_details?.org_add_nep}
                </td>
                <td align='right' className={`w-[25%] text-[11px] text-black font-normal ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Date: " : "मिति: "} {language === "Eng" ? DateNow : NumberToNepaliNum(DateNow)}
                </td>
              </tr>
              <tr >
                <td align='center' colSpan={2} className={`w-[25%] underline text-black font-bold text-[15px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Advance Voucher Report" : "गोश्वारा भौचर रिपोर्ट"}
                </td>
                <td className="w-[25%]">
                </td>
              </tr>
              <tr>
                <td align='center' colSpan={2} className={`w-[25%] text-black font-light text-[11px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Date: " : "कारोवार मिति: "}
                  {date_report?.date_from} -  {date_report?.date_to}
                </td>
                <td align='right' className={`w-[25%] text-[11px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Voucher No.:........" : "भौचर नम्बर:........."}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className={`relative`}>
          <table className='w-full'>
            <thead className='font-public-sans text-[12px] text-slate900 bg-slate-50 z-50 sticky top-0'>
              <tr>
                <th rowSpan={2} className={`border border-slate-300 py-1 w-10 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>{language === "Eng" ? "S.N." : "स.नं."}</th>
                <th rowSpan={2} className={`border border-slate-300 py-1 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>{language === "Eng" ? "Particulars" : "विवरण"}</th>
                <th rowSpan={2} className={`border border-slate-300 py-1 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>{language === "Eng" ? "GLID" : "भौ.कोड."}</th>
                <th colSpan={2} className={`border border-slate-300 py-1 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>{language === "Eng" ? "Particular Amount" : "विवरण कुल रकम"}</th>
                <th colSpan={2} className={`border border-slate-300 py-1 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>{language === "Eng" ? "Total Amount" : "कुल रकम"}</th>
              </tr>
              <tr>
                <th className={`border border-slate-300 py-1 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}> {language === "Eng" ? "Debit Amount" : "डेबिट रकम"}</th>
                <th className={`border border-slate-300 py-1 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>{language === "Eng" ? "Credit Amount" : "क्रेडिट रकम"}</th>
                <th className={`border border-slate-300 py-1 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}> {language === "Eng" ? "Debit Amount" : "डेबिट रकम"}</th>
                <th className={`border border-slate-300 py-1 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>{language === "Eng" ? "Credit Amount" : "क्रेडिट रकम"}</th>
              </tr>
            </thead>
            <tbody>

              {
                onAdvVoucherReport?.results?.map((voucher: any, index: number) => (
                  <tr key={index} className='font-public-sans cursor-pointer hover:bg-slate100 text-[12px] text-slate900 py-1'>
                    <td align='center' className={`border border-slate-300 px-2 py-1 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>{index + 1}.</td>
                    <td className={`border border-slate-300 px-2 py-1 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>

                      <div className='flex justify-between'>
                        <div>
                          <span className={`font-bold ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>{language === "Eng" ? voucher?.glname : voucher?.glnamenep}</span> 
                          
                          <span className={`pl-8 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>{language === "Eng" ? voucher?.sub_ledg_name : voucher?.sub_ledg_name_nep}</span> 
                                                    <span className={`pl-8 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>{language === "Eng" ? voucher?.particular_name : voucher?.particunamenep}</span> 

                          </div>
                        <div>
                          <span className={`pl-8 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>{voucher?.subamt ? formatMoney_2(voucher?.subamt || "") : ""}</span>
                        </div>
                      </div></td>

                    <td align='center' className={`${language === "Eng" ? "font-public-sans" : "font-nepali"} border border-slate-300 px-2 py-1`}>{voucher.glid}</td>
                    <td align='right' className={`${language === "Eng" ? "font-public-sans" : "font-nepali"} border border-slate-300 px-2 py-1`}>{formatMoney_2(voucher.particulardebitamt || "0")}</td>
                    <td align='right' className={`${language === "Eng" ? "font-public-sans" : "font-nepali"} border border-slate-300 px-2 py-1`}>{formatMoney_2(voucher.particularcreditamt || "0")}</td>
                    <td align='right' className={`${language === "Eng" ? "font-public-sans" : "font-nepali"} border border-slate-300 px-2 py-1`}>{formatMoney_2(voucher.debitamt || "0")}</td>
                    <td align='right' className={`${language === "Eng" ? "font-public-sans" : "font-nepali"} border border-slate-300 px-2 py-1`}>{formatMoney_2(voucher.creditamt || "0")}</td>
                  </tr>
                ))
              }
              <tr className='font-public-sans bg-slate100 font-bold text-[12px] text-slate900 py-1'>
                <td align='right' colSpan={2} className={`${language === "Eng" ? "font-public-sans" : "font-nepali"} border border-slate-300 px-2 py-1`}>{language === "Eng" ? "Total Amount" : "कुल रकम"}</td>
                <td align='right' className={`${language === "Eng" ? "font-public-sans" : "font-nepali"} border font-bold border-slate-300 px-2 py-1`}></td>
                <td align='right' className={`${language === "Eng" ? "font-public-sans" : "font-nepali"} border border-slate-300 px-2 py-1`}>{formatMoney_2(Math.abs(totalPartiDredit))}</td>
                <td align='right' className={`${language === "Eng" ? "font-public-sans" : "font-nepali"} border border-slate-300 px-2 py-1`}>{formatMoney_2(Math.abs(totalPartiCredit))}</td>
                <td align='right' className={`${language === "Eng" ? "font-public-sans" : "font-nepali"} border border-slate-300 px-2 py-1`}>{formatMoney_2(Math.abs(anotherDebitAmt))}</td>
                <td align='right' className={`${language === "Eng" ? "font-public-sans" : "font-nepali"} border border-slate-300 px-2 py-1`}>{formatMoney_2(Math.abs(anotherCreditAmt))}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <br />
      </div >
    </Fragment>

  )
}

export default PrintAdvanedVoucher


